import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

function formatDateTime(dt: string): string {
  return new Date(dt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function AdminUsersPage() {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => { loadUsers(); }, []);

  async function loadUsers() {
    const { data } = await supabase
      .from('profiles')
      .select('*, companies( id, name, rechtsform, sitzland, handelsregister, ansprechpartner_vorname, ansprechpartner_nachname, position, telefon )')
      .order('created_at', { ascending: false });
    setUsers(data || []);
    setLoading(false);
  }

  async function setStatus(userId: string, status: string) {
    await supabase.from('profiles').update({ status }).eq('id', userId);
    loadUsers();
  }

  const filtered = filter === 'all' ? users : users.filter((u) => u.status === filter);

  if (loading) return <div className="container-content py-12"><p className="text-text-secondary">Laden...</p></div>;

  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Nutzer und Unternehmen</h1>

      <div className="flex gap-3 mb-6">
        {['all', 'PENDING_EMAIL', 'PENDING_KYC', 'AKTIV', 'GESPERRT'].map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1 text-sm rounded-sm border ${filter === f ? 'bg-primary text-white border-primary' : 'border-surface-border text-text-secondary hover:bg-surface-alt'}`}>
            {f === 'all' ? 'Alle' : f}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>Unternehmen</th>
              <th>Rechtsform</th>
              <th>Handelsregister</th>
              <th>Status</th>
              <th>Erstellt</th>
              <th>Aktion</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((u) => (
              <tr key={u.id}>
                <td>{u.companies?.ansprechpartner_vorname} {u.companies?.ansprechpartner_nachname}</td>
                <td>{u.companies?.name}</td>
                <td>{u.companies?.rechtsform}</td>
                <td className="font-mono text-xs">{u.companies?.handelsregister}</td>
                <td><span className="font-mono text-sm">{u.status}</span></td>
                <td className="text-sm">{formatDateTime(u.created_at)}</td>
                <td>
                  <div className="flex gap-2">
                    {u.status === 'PENDING_KYC' && (
                      <>
                        <button onClick={() => setStatus(u.id, 'AKTIV')} className="text-xs btn-primary">Freigeben</button>
                        <button onClick={() => setStatus(u.id, 'GESPERRT')} className="text-xs btn-danger">Sperren</button>
                      </>
                    )}
                    {u.status === 'AKTIV' && (
                      <button onClick={() => setStatus(u.id, 'GESPERRT')} className="text-xs btn-danger">Sperren</button>
                    )}
                    {u.status === 'GESPERRT' && (
                      <button onClick={() => setStatus(u.id, 'AKTIV')} className="text-xs btn-secondary">Freigeben</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
